<script>
    import ArrowLeft from "@rgossiaux/svelte-heroicons/solid/ArrowLeft";
    import authenticate from "./authService";
    import * as urls from "../json/config.json";
    import Spinner from './spinner.svelte';
    import { email, showDisclaimer, signup } from "./store";
    let signUp_message = urls.login_message_default;
    let login_message  = urls.login_message_default;
    let error_message  = ""

    let password;

    let otp_sent = false;

    let spinner = false;
    
    function validateEmail(email) {
        var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
    }

    const handleLogin = async (email, password) => {
        if (email == "" || email== undefined|| password == "" || password == undefined){
            error_message = urls.login_error_email_pass;
            return
        }
        if (!validateEmail(email)){
            error_message = urls.error_email;
            return
        }

        error_message = ""
        spinner = true;
        authenticate(email, password)
        .then ( () => {
            login_message = urls.login_success;
            spinner = false
        })
        .catch ( () => {
            login_message = urls.login_failed;
            spinner = false
        })
    }

    const sendOTP = async (email) => {
        if (email == "" ){
            error_message = urls.error_email_required;
        }

        if (!validateEmail(email)){
            error_message = urls.error_email;
            return
        }

        error_message = ""
        let formData = new FormData();
        formData.append('email', email);

        try{
            spinner = true
            const response = await fetch(urls.sendOTP, {
                method: 'POST',
                body: formData
            });
            spinner = false
            if(response.ok) {
                otp_sent = true;
                login_message = urls.send_otp_sent;
            } else if(response.status === 500){
                login_message = urls.send_otp_subscribe;
            }
            else {
                throw new Error('Request Failed', response.status);
            }
        } catch (error) {
            throw new Error('An error occurred:', error);
        }
    }

    const handleSignUp = async (email) => {
        if (email == "" ){
            error_message = urls.error_email_required;
        }

        if (!validateEmail(email)){
            error_message = urls.error_email;
            return
        }

        error_message = ""
        let formData = new FormData();
        formData.append('email', email);

        try{
            spinner = true
            const response = await fetch(urls.subscribe, {
                method: 'POST',
                body: formData
            });
            spinner = false
            if(response.ok){
                signUp_message = urls.signup_subscribed;

            } else if(response.status === 500) {
                signUp_message = urls.signup_requested;

            }
            else {
                throw new Error('Request failed', response.status);
            }
        } catch (error) {
            throw new Error('An error occurred', error);
        }
    }
</script>

<div class="spinner">
    {#if spinner === true}
        <Spinner/>
    {/if}
</div>

<div class="container">
    {#if $signup === false}
        <form class="login">
            <p class="info">{login_message}</p><br>
            {#if (error_message != undefined || error_message != "")}
                <div class = "error">{error_message}</div>
            {/if}

            <label for="email"></label>
            <input type="email" id="email" placeholder="Email" bind:value={$email} required><br>
            {#if otp_sent}
                <input type="password" id="password" placeholder="One time password" bind:value={password} required><br>
                <button type="button" class="login-buttons" on:click={handleLogin($email, password)}>
                    Login
                </button>
                <button type="button" class="signUpBtn" on:click={sendOTP($email)}>
                    Resend OTP
                </button>
            {:else}
                <button type="button" class="login-buttons" on:keyup={(event) => {console.log(event)}} on:click={sendOTP($email)}>
                    Send OTP
                </button>
                <button class="signUpBtn" on:click={() => {otp_sent = true;}}>Already have an OTP?</button>
            {/if}
            <br>

           <button class="signUpBtn" type="button" on:click={() => {showDisclaimer.set(true);}}>Don't have an account? Subscribe</button>
        </form>
        
    {:else}
        <button class="backBtn" on:click={() => signup.set(false)}><ArrowLeft color="#fff" height="25" width="25"/></button>
        <form class="login" on:submit|preventDefault={handleSignUp($email)}>
            <p class="info">
                {signUp_message}
            </p>
            <label for="email"></label>
            <input type="email" id="email" placeholder="Email" bind:value={$email} required><br>
            <button type="submit" class="login-buttons">
                Sign up
            </button><br>
        </form>
    {/if}
    
</div>

<style>
    .container{
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
    }
    .login{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-top: 15px;
        margin-bottom: 15px;
        width: 100%;
    }
    .backBtn{
        position: absolute;
        left: 0;
        top: 0;
        margin-top: 9px;
        background: transparent;
        border: 0;
        border-radius: 2px;
    }
    .info{
        width: 50%;
        text-align: center;
    }
    #email{
        width: 250px;
        margin-top: 5px;
        margin-bottom: 5px;
    }
    #password{
        width: 250px;
        margin-bottom: 10px;
    }
    .login-buttons{
		height: 30px;
		max-height: 30px;
		flex-grow: 0;
		font-size: 0.9rem;
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		gap: 10px;
		padding: 10px 15px;
		border-style: solid;
		border-width: 3px;
		border-image-source: linear-gradient(112deg, #9c0ccf 0%, #5157d4 100%);
		border-image-slice: 1;
		border-radius: 4px;
		background-image: linear-gradient(112deg, #9c0ccf 0%, #5157d4 100%);
		color: ghostwhite;
		cursor: pointer;
		box-sizing: border-box;
	}
    .signUpBtn{
        color: #81edf5;
        background: transparent;
        border: 0;
        text-decoration: underline;
    }
    .signUpBtn:hover{
        color: #81c5f5;
    }
    .error{
        color: #ff0063;

    }
    .spinner{
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
        z-index: 1000;
	}
</style>